import { useCallback } from 'react';
import axios from 'axios';
import type { CommunityType, ExtendedCommunity } from '@/types/community';

export const useCommunity = () => {
  const createCommunity = useCallback(async (data: Partial<CommunityType>) => {
    try {
      const response = await axios.post('/api/community', data);
      return response.data;
    } catch (error) {
      console.error('Error creating community:', error);
      throw error;
    }
  }, []);

  const getCommunity = useCallback(async (name: string) => {
    try {
      const response = await axios.get(`${process?.env?.NEXT_PUBLIC_API_URL}/community?name=${name}`);
      return response.data;
    } catch (error) {
      console.error('Error getting community:', error);
      throw error;
    }
  }, []);

  const getAllCommunities = useCallback(async () => {
    try {
      const response = await axios.get('/api/community');
      return response.data;
    } catch (error) {
      console.error('Error getting communities:', error);
      throw error;
    }
  }, []);

  const joinCommunity = useCallback(async (communityId: string) => { // Changed from number to string for UUIDs
    try {
      const response = await axios.post(`${process?.env?.NEXT_PUBLIC_API_URL}/community/${communityId}/join`);
      return response.data;
    } catch (error) {
      console.error('Error joining community:', error);
      throw error;
    }
  }, []);

  const leaveCommunity = useCallback(async (communityId: string) => { // Changed from number to string for UUIDs
    try {
      const response = await axios.post(`${process?.env?.NEXT_PUBLIC_API_URL}/community/${communityId}/leave`);
      return response.data;
    } catch (error) {
      console.error('Error leaving community:', error);
      throw error;
    }
  }, []);

  const addModerator = useCallback(async (communityId: number, userId: number) => {
    try {
      const response = await axios.post(`${process?.env?.NEXT_PUBLIC_API_URL}/community/${communityId}/moderator`, {
        userId
      });
      return response.data;
    } catch (error) {
      console.error('Error adding moderator:', error);
      throw error;
    }
  }, []);

  const removeModerator = useCallback(async (communityId: number, userId: number) => {
    try {
      const response = await axios.delete(
        `${process?.env?.NEXT_PUBLIC_API_URL}/community/${communityId}/moderator?userId=${userId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error removing moderator:', error);
      throw error;
    }
  }, []);

  return {
    createCommunity,
    getCommunity,
    getAllCommunities,
    joinCommunity,
    leaveCommunity,
    addModerator,
    removeModerator,
  };
};
